import React from 'react'
import { CircularProgress } from '@mui/material'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import TrimmedTextField from './TrimmedTextField'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormTextInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
  loading?: boolean
  disabled?: boolean
  size?: 'small' | 'medium'
}

const EntityFormTextInput = ({
  field,
  fieldValue,
  updateField,
  error,
  loading = false,
  disabled = false,
  size,
}: EntityFormTextInputProps) => (
  <TrimmedTextField
    key={`field-${field.id.toString()}`}
    required={field.required}
    label={field.name}
    value={fieldValue?.value ?? ''}
    onChange={(event) => updateField({ fieldId: field.id, type: field.type, value: event.target.value })}
    error={error}
    disabled={disabled || loading}
    placeholder={loading ? ' ' : undefined}
    size={size}
    InputLabelProps={loading ? { shrink: true } : undefined}
    InputProps={{
      endAdornment: loading ? <CircularProgress size={20} /> : undefined,
    }}
  />
)

export default EntityFormTextInput
